export const getTitleFromFilters = ({ selectedProduct, filters = [] }: any) => {
  const selectedProductLabel = filters.find(
    ({ value }) => value === selectedProduct,
  )?.label

  return selectedProductLabel
}
